/**
 * Force untranslate using Google Translate's internal methods
 */

export function forceUntranslate(): boolean {
    try {        
        // Method 1: Direct Google Translate API call if available
        const google = (window as any).google;
        if (google?.translate?.TranslateElement) {
            // Try to access the instance
            const instances = google.translate.TranslateElement.getInstance?.();
            if (instances) {
                instances.restore?.();
                return true;
            }
        }
        
        // Method 2: Simulate clicking the "Show Original" button
        const frames = document.getElementsByTagName('iframe');
        for (let i = 0; i < frames.length; i++) {
            if (frames[i].id && frames[i].id.indexOf('goog-te') !== -1) {
                try {
                    const frameDoc = (frames[i] as HTMLIFrameElement).contentDocument;
                    if (frameDoc) {
                        // Look for restore/original button
                        const buttons = frameDoc.getElementsByTagName('button');
                        for (let j = 0; j < buttons.length; j++) {
                            const btnText = buttons[j].textContent || '';
                            if (btnText.toLowerCase().includes('original') || 
                                btnText.toLowerCase().includes('show') ||
                                btnText.toLowerCase().includes('restore')) {
                                buttons[j].click();
                                return true;
                            }
                        }
                    }
                } catch (e) {
                    // Cross-origin, can't access
                }
            }
        }
        
        // Method 3: Force remove all Google Translate modifications
        const select = document.querySelector('.goog-te-combo') as HTMLSelectElement;
        if (select) {
            // Create a more compatible event
            select.value = '';
            
            // Try multiple event types
            const events = ['change', 'input', 'click'];
            events.forEach(eventType => {
                const event = new Event(eventType, {
                    bubbles: true,
                    cancelable: true
                });
                select.dispatchEvent(event);
            });
            
            // Also try legacy event creation
            if (typeof Event !== 'function') {
                const evt = document.createEvent('Event');
                evt.initEvent('change', true, true);
                select.dispatchEvent(evt);
            }
            
            return true;
        }
        
        return false;
    } catch (error) {
        console.error('Error in forceUntranslate:', error);
        return false;
    }
}

// Add to window for debugging
(window as any).forceUntranslate = forceUntranslate;